import type { ArticleCard as ArticleCardType } from 'types/capi/shared';

import ArticleCard from '~/components/ArticleCard';

import { MODULE_TYPES } from './index';

type Props = {
  items: ArticleCardType[];
  modulePosition: number;
};

export default function Highlights({ items, modulePosition }: Props) {
  const [hero, card1, card2, card3] = items;
  if (!hero || !card1 || !card2 || !card3) return null;

  const shared = {
    modulePosition,
    moduleType: MODULE_TYPES.highlights,
    name: 'LATEST_NEWS' as const,
    pagePosition: 'Homepage Article Highlights' as const
  };

  return (
    <div className="w-full bg-grey-tile">
      <div className="content-width flex flex-col gap-6 py-10 md:py-20">
        <ArticleCard
          {...shared}
          className="hidden sm:block"
          item={hero}
          options={{ titleSize: 'lg' }}
          position={1}
          variant="16/9-text-over"
        />
        <ArticleCard
          {...shared}
          className="block sm:hidden"
          item={hero}
          position={1}
          variant="4/5-text-over"
        />

        <div className="carousel-width no-scrollbar flex gap-6 overflow-y-hidden">
          <ArticleCard
            {...shared}
            item={card1}
            position={2}
            variant="16/9-text-under"
          />
          <ArticleCard
            {...shared}
            item={card2}
            position={3}
            variant="16/9-text-under"
          />
          <ArticleCard
            {...shared}
            item={card3}
            position={4}
            variant="16/9-text-under"
          />
        </div>
      </div>
    </div>
  );
}
